import { clone } from '@jack-henry/frontend-utils/functions';
import { CompanyBillPayProductModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: CompanyBillPayProductModelDto = {
    id: 0,
    type: 'BillPayProductFeature',
    productUniqueId: '',
    isConfigurable: false,
    allowIPayBusinessBillPayForMobile: false,
};

export class BillPayProductFeature extends CompanyProductFeature<CompanyBillPayProductModelDto> {
    constructor(dto: CompanyBillPayProductModelDto = clone(defaultDto)) {
        super(dto);
    }

    public get allowIPayBusinessBillPayForMobile(): boolean {
        return this.dto.allowIPayBusinessBillPayForMobile ?? false;
    }

    public set allowIPayBusinessBillPayForMobile(value: boolean) {
        this.dto.allowIPayBusinessBillPayForMobile = value;
    }

    public get defaultBillPayAccountId(): number | undefined {
        return this.dto.defaultAccountId;
    }

    public set defaultBillPayAccountId(value: number) {
        this.dto.defaultAccountId = value;
    }
}
